import React from "react";
import { motion } from "framer-motion";
import { PROFILE, MARQUEE_TECH } from "@/data/portfolio";
import { ABOUT } from "@/constants/testIds";
import SectionHeading from "@/components/molecules/SectionHeading";

export default function About() {
  return (
    <section id="about" data-testid={ABOUT.section} className="section relative">
      <div className="container-x relative">
        <SectionHeading
          overline="01 — About"
          title="Engineering at the edge of craft & speed."
          description="I care deeply about the seams of a product — accessibility, motion, performance, internationalization — the stuff users feel without naming it."
        />

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {/* Portrait */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="md:col-span-5 row-span-2 relative rounded-3xl overflow-hidden border border-[color:var(--border)] bg-[color:var(--surface)] min-h-[420px]"
          >
            <img
              src={PROFILE.aboutImage}
              alt="Suyash"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--bg)] via-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <div className="label-mono">Indore, IN · UTC+5:30</div>
              <div className="font-display text-2xl mt-1">{PROFILE.name}</div>
            </div>
          </motion.div>

          {/* Summary */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="md:col-span-7 rounded-3xl border border-[color:var(--border)] bg-[color:var(--surface)] p-6 md:p-8"
          >
            <div className="label-mono mb-3">// summary</div>
            <p className="text-lg leading-relaxed font-body text-[color:var(--text)]">
              {PROFILE.summary}
            </p>
          </motion.div>

          {/* Highlights mini grid */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="md:col-span-4 rounded-3xl border border-[color:var(--border)] bg-[color:var(--surface)] p-6"
          >
            <div className="label-mono mb-4">// fun facts</div>
            <ul className="space-y-3">
              {PROFILE.funFacts.map((f, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-[color:var(--text)]">
                  <span className="mt-1 text-[color:var(--accent)]">▹</span>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Tech marquee */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="md:col-span-3 rounded-3xl border border-[color:var(--border)] bg-[color:var(--surface)] p-6 overflow-hidden relative"
          >
            <div className="label-mono mb-4">// daily-stack</div>
            <div className="relative h-32 overflow-hidden">
              <div className="absolute inset-0 flex flex-col gap-3 animate-marquee" style={{ animationDuration: "20s" }}>
                {[...MARQUEE_TECH, ...MARQUEE_TECH].map((t, i) => (
                  <span key={i} className="font-mono text-sm text-[color:var(--text-muted)] whitespace-nowrap">
                    ▸ {t}
                  </span>
                ))}
              </div>
              <div className="absolute inset-0 bg-gradient-to-b from-[color:var(--surface)] via-transparent to-[color:var(--surface)] pointer-events-none" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
